<template>
  <div v-if="content" class="alert">
    <div :style="iconStyle(content.color)" class="alert-icon">
      <fai class="icon" :icon="getIcon(content.icon)"></fai>
    </div>
    <div :style="border(content.color)" class="alert-content">
      <h5 :style="titleColor(content.color)" v-html="content.title"></h5>
      <vue-markdown class="markdown">{{content.text}}</vue-markdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    getIcon(icon) {
      if (icon) {
        return icon.icon.replace("fa-", "");
      }
    },
    border(color) {
      if (color) {
        return {
          borderColor: color.color
        };
      }
    },
    titleColor(color) {
      if (color) {
        return {
          color: color.color
        };
      }
    },
    iconStyle(color) {
      if (color) {
        return {
          backgroundColor: color.color
        };
      }
    }
  }
};
</script>

<style lang="scss">
.alert {
  width: 1000px;
  max-width: $max-width;
  margin: 1.5em auto;
  display: flex;
  box-shadow: 1px 3px 6px 0px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  overflow: hidden;
  .alert-icon {
    padding: 25px;
    display: flex;
    width: 150px;
    align-items: center;
    justify-content: center;
    .icon {
      color: #fff;
      font-size: 27px;
    }
  }
  .alert-content {
    width: 100%;
    border-right: 5px solid #fff;
    background-color: #edefed;
    padding: 20px 15px;
    h5 {
      font-weight: bold;
      padding-bottom: 10px;
    }
    p,
    li {
      //font-size: 18px;
      color: #777;
    }
  }
}
@media screen and (max-width: 700px) {
  .alert {
    .alert-icon {
      display: none;
    }
  }
}
</style>
